import React from 'react';
import { Content, Row, Col, Title, Text, Pagination, Button } from 'components';
import { SideMenu } from '../components';
import { DatePicker, Empty, Flex, Spin } from 'antd';
import { stringToMoneyFormat } from 'utils';
import MessageAlert from 'utils';
import dayjs from 'dayjs';
import Formatter from 'utils/Formatter';

const PERIOD = [
  {
    label: '1개월',
    value: 1,
    key: 'month',
  },
  {
    label: '3개월',
    value: 3,
    key: 'month',
  },
  {
    label: '6개월',
    value: 6,
    key: 'month',
  },
  {
    label: '1년',
    value: 1,
    key: 'year',
  },
];

const DATE_FORMAT = 'YYYY/MM/DD';
const PAGE_COUNT = 5;
const PAGE_SIZE = 10;

const TAP = [
  {
    label: '전체',
    value: 'ALL',
  },
  {
    label: '적립',
    value: 'EARNED',
  },
  {
    label: '사용',
    value: 'USED',
  },
  {
    label: '차감',
    value: 'DEDUCTED',
  },
  {
    label: '환불',
    value: 'REFUNDED',
  },
  {
    label: '만료',
    value: 'EXPIRED',
  },
];

const POINT_TYPE = {
  EARNED: '적립',
  USED: '사용',
  DEDUCTED: '차감',
  REFUNDED: '환불',
  EXPIRED: '만료',
};

const MypagePointPresenter = (props) => {
  /* ===== Props ===== */
  const {
    history,
    selected,
    onSelect,
    isLoading,
    setIsLoading,
    point,
    screenSize,
  } = props;

  /* ===== State ===== */
  // 내역
  const [historyList, setHistoryList] = React.useState([]);
  // Period Range
  const [selectedPeriod, setSelectedPeriod] = React.useState(selected);
  const [period, setPeriod] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1); // 현재 페이지
  // Tap
  const [selectedTab, setSelectedTab] = React.useState('ALL');

  /* ===== Variables ===== */
  const styles = {
    buttonGroup: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    tabContainer: {
      display: 'flex',
      alignItems: 'center',
      borderBottom: '2px solid var(--black-color)',
    },
    tab: {
      width: screenSize >= 768 ? 160 : 130,
      height: screenSize >= 768 ? 66 : 55,
      lineHeight: screenSize >= 768 ? '66px' : '55px',
      textAlign: 'center',
      cursor: 'pointer',
      fontSize: screenSize >= 768 ? 16 : 14,
      border: '1px solid gray',
      backgroundColor: 'transparent',
      color: 'gray',
    },
    activeTab: {
      fontWeight: 'bold',
      backgroundColor: 'black',
      color: 'white',
      border: '2px solid black',
    },
    emptyState: {
      textAlign: 'center',
      padding: 20,
      fontSize: 16,
      color: 'gray',
    },
    button: {
      width: '25%',
      borderRadius: '0',
      border: '1px solid var(--light-gray-color)',
      backgroundColor: '#fff',
      color: 'var(--light-gray-color)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 700,
      fontSize: screenSize >= 768 ? 16 : 14,
      cursor: 'pointer',
    },
    activeButton: {
      border: '1px solid var(--black-color)',
      color: 'var(--black-color)',
    },
  };

  /* ===== Function ===== */
  /**
   * 검색기간 설정
   * --
   */
  const handleDateChange = (date, key) => {
    // if (selected[0] === date && selected[1] === key) {
    //   setPeriod([]);
    //   setSelectedPeriod([...selected]);
    // } else {
    const start = dayjs().subtract(date, key).startOf('day');
    setPeriod([start, dayjs().endOf('day')]);
    setSelectedPeriod([date, key]);
    // }
  };

  /**
   * 기간 검색
   * --
   */
  const handlePeriodSearch = () => {
    const [start, end] = period;

    if (!start || !end) {
      return MessageAlert.info('검색 기간을 선택해주세요!');
    }

    onSelect(selectedPeriod);
  };

  /* ===== Hooks ===== */
  /**
   * 탭별 페이 목록 정제
   * --
   */
  React.useEffect(() => {
    setIsLoading(true);

    if (!history?.length) {
      setTimeout(() => {
        setHistoryList([]);
        setIsLoading(false);
      }, 500);

      return;
    }

    const filtered = history
      ?.filter((h) => (selectedTab === 'ALL' ? h : h.type === selectedTab))
      ?.sort((a, b) => b.created_at - a.created_at);

    setTimeout(() => {
      setHistoryList(filtered);
      setIsLoading(false);
    }, 500);
    // eslint-disable-next-line
  }, [history, selectedTab]);

  /* ===== Render ===== */
  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={screenSize >= 768 ? '120px 0px 200px' : '60px 0'}
        >
          <Row gutter={25}>
            <Col x={0} md={1} xl={2}></Col>
            <Col x={0} md={6} xl={4}>
              <SideMenu />
            </Col>
            <Col x={24} md={16} xl={16}>
              <Content
                maxWidth={'100%'}
                padding={
                  screenSize >= 1200
                    ? '0 0 0 95px'
                    : screenSize >= 768
                    ? '0 0 0 20px'
                    : '0'
                }
              >
                {/* 포인트 내역 */}
                <Title
                  style={{
                    fontSize:
                      screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
                    fontWeight: 700,
                    marginBottom: 24,
                    fontFamily: 'Pretendard',
                  }}
                >
                  포인트
                </Title>

                <Content
                  maxWidth={'100%'}
                  backgroundColor="var(--black-color)"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    height: screenSize >= 768 ? 164 : 'auto',
                    padding: 40,
                    marginBottom: 80,
                    borderRadius: 2,
                    flexDirection: screenSize >= 768 ? 'unset' : 'column',
                    gap: screenSize >= 768 ? 'unset' : '10px',
                  }}
                >
                  {/* 최상단 좌측 컨텐츠 시작 */}
                  <div
                    style={{
                      width: screenSize >= 768 ? '50%' : '100%',
                      borderRight:
                        screenSize >= 768
                          ? '1px solid var(--white-color)'
                          : 'none',
                      borderBottom:
                        screenSize >= 768
                          ? 'none'
                          : '1px solid var(--white-color)',
                      color: 'var(--white-color)',
                      paddingBottom: screenSize >= 768 ? 'none' : 20,
                      marginBottom: screenSize >= 768 ? 'none' : 20,
                    }}
                  >
                    <Text
                      style={{
                        color: 'var(--white-color)',
                        display: 'flex',
                        flexDirection: 'column',
                        marginRight: screenSize >= 768 ? 40 : '0',
                        size: 18,
                        height: '100%',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span>사용 가능한 포인트</span>
                      <div
                        style={{
                          marginLeft: 'auto',
                          fontWeight: 700,
                          fontSize: 24,
                        }}
                      >
                        {stringToMoneyFormat(point?.useable)}
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: 18,
                            marginLeft: 8,
                          }}
                        >
                          p
                        </span>
                      </div>
                    </Text>
                  </div>
                  {/* 최상단 좌측 컨텐츠 끝 */}

                  {/* 최상단 우측 컨텐츠 시작 */}
                  <div
                    style={{
                      width: screenSize >= 768 ? '50%' : '100%',
                      color: 'var(--white-color)',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Text
                      style={{
                        color: 'var(--white-color)',
                        display: 'flex',
                        marginLeft: screenSize >= 768 ? 40 : 0,
                        size: 18,
                        height: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <span>누적 포인트</span>
                      <div
                        style={{
                          fontWeight: 700,
                        }}
                      >
                        {stringToMoneyFormat(point.total)}
                        <span
                          style={{
                            fontWeight: 400,
                            marginLeft: 8,
                          }}
                        >
                          p
                        </span>
                      </div>
                    </Text>
                    <Text
                      style={{
                        color: 'var(--white-color)',
                        display: 'flex',
                        marginLeft: screenSize >= 768 ? 40 : 0,
                        size: 18,
                        height: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <span>소멸 예정 포인트</span>
                      <div
                        style={{
                          fontWeight: 700,
                        }}
                      >
                        {stringToMoneyFormat(point?.expiry)}
                        <span
                          style={{
                            fontWeight: 400,
                            marginLeft: 8,
                          }}
                        >
                          p
                        </span>
                      </div>
                    </Text>
                  </div>
                  {/* 최상단 우측 컨텐츠 끝 */}
                </Content>

                {/* 탭 메뉴 */}
                <div style={styles.tabContainer}>
                  {TAP.map((tap) => (
                    <div
                      key={tap.label}
                      style={{
                        ...styles.tab,
                        ...(selectedTab === tap.value ? styles.activeTab : {}),
                      }}
                      onClick={() => {
                        setSelectedTab(tap.value);
                        setCurrentPage(1); // 탭 변경 시 페이지를 초기화
                      }}
                    >
                      {tap.label}
                    </div>
                  ))}
                </div>

                {/* 개월 수 */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '32px 0',
                    borderBottom: '1px solid #ddd',
                    flexDirection: screenSize >= 768 ? 'unset' : 'column',
                    gap: screenSize >= 768 ? 'unset' : '10px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      width: screenSize >= 768 ? '51.44%' : '100%',
                      height: 48,
                    }}
                  >
                    <div style={styles.buttonGroup}>
                      {PERIOD.map((period) => (
                        <button
                          key={`${period.value}-${period.key}-${period.label}`}
                          style={{
                            ...styles.button,
                            ...(selectedPeriod[0] === period.value &&
                            selectedPeriod[1] === period.key
                              ? styles.activeButton
                              : {}),
                          }}
                          onClick={() => {
                            handleDateChange(period.value, period.key);
                            setCurrentPage(1); // 기간 변경 시 페이지를 초기화
                          }}
                        >
                          {period.label}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: screenSize >= 768 ? '46.3%' : '100%',
                    }}
                  >
                    <DatePicker.RangePicker
                      style={{
                        width: '64%',
                        height: 48,
                        border: '1px solid var(--light-gray-color)',
                      }}
                      value={[
                        period?.[0] ? dayjs(period?.[0], DATE_FORMAT) : '',
                        period?.[1] ? dayjs(period?.[1], DATE_FORMAT) : '',
                      ]}
                      format={DATE_FORMAT}
                      placeholder={['시작일', '종료일']}
                      minDate={dayjs().subtract(365, 'day')}
                      maxDate={dayjs()}
                      onChange={(_, dateString) => setPeriod(dateString)}
                    />
                    <Button
                      style={{
                        width: '31.12%',
                        borderRadius: '0',
                        fontWeight: 700,
                        fontSize: screenSize >= 768 ? 16 : 14,
                        backgroundColor: 'var(--white-color)',
                        color: 'var(--black-color)',
                        border: '1px solid var(--black-color)',
                      }}
                      onClick={() => handlePeriodSearch()}
                    >
                      조회
                    </Button>
                  </div>
                </div>

                {/* 포인트 목록 */}
                <div>
                  {historyList.length ? (
                    historyList
                      ?.slice(
                        (currentPage - 1) * PAGE_SIZE,
                        currentPage * PAGE_SIZE
                      )
                      ?.map((_item, _index) => (
                        <div
                          key={`point-history-${_index}-${_item.point_history_id}`}
                          style={{
                            borderBottom: '1px solid #ddd',
                            padding: 10,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '32px 0',
                              width: '100%',
                              justifyContent: 'space-between',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                gap: screenSize >= 768 ? 0 : 20,
                              }}
                            >
                              <Text
                                size={16}
                                style={{
                                  width: screenSize >= 768 ? 124 : 'auto',
                                }}
                              >
                                {Formatter.unixToDate(
                                  _item.created_at,
                                  'YYYY.MM.DD'
                                )}
                              </Text>
                              <Flex vertical>
                                <Text
                                  size={16}
                                  style={{
                                    width: screenSize >= 768 ? 124 : 'auto',
                                  }}
                                >
                                  {POINT_TYPE[_item.type]}
                                </Text>

                                <Text size={12} color={'#BDBDBD'}>
                                  {_item.memo}
                                </Text>
                              </Flex>
                            </div>
                            <Text
                              size={16}
                              weight={700}
                              color={'var(--red-secondary-color)'}
                              style={{
                                minWidth: 100,
                                textAlign: 'end',
                              }}
                            >
                              {_item?.type === 'EARNED' ||
                              _item?.type === 'REFUNDED'
                                ? '+ '
                                : '- '}
                              {stringToMoneyFormat(
                                _item.type !== 'EXPIRED'
                                  ? _item?.point
                                  : _item?.point - _item?.use_point
                              )}
                              원
                            </Text>
                            {/* <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <Text size={16}>{item.product_name}</Text>
                        <Text size={14} color={'var(--dark-gray-color)'}>
                          {item.product_data}
                        </Text>
                            </div> */}
                          </div>
                          {/* <Text
                            size={16}
                            weight={700}
                            color={'var(--red-secondary-color)'}
                          >
                            {item.status === '주문적립' ? '+' : '-'}
                        {item.point}P
                          </Text> */}
                        </div>
                      ))
                  ) : (
                    <div style={{ textAlign: 'center', padding: '40px 0' }}>
                      <Empty description={'포인트 내역이 없습니다.'} />
                    </div>
                  )}
                </div>

                {/* 페이지네이션 */}
                <div style={{ marginTop: 100 }}>
                  <Pagination
                    total={historyList.length}
                    pageSize={PAGE_COUNT}
                    current={currentPage}
                    onChange={(page) => setCurrentPage(page)}
                    showSizeChanger
                    onShowSizeChange={(current, size) => {
                      setCurrentPage(1); // 페이지 크기 변경 시 페이지 초기화
                    }}
                    showPage={5}
                    buttonStyle={{
                      fontSize: 16,
                      fontWeight: 700,
                      color: '#999999',
                      background: 'none',
                      width: 28,
                      height: 28,
                    }}
                    isButton={true}
                    activeStyle={{
                      color: `var(--black-color) !important`,
                      borderBottom: '2px solid #111111',
                    }}
                    hoverStyle={{
                      color: `var(--black-color) !important`,
                    }}
                    navStyle={{
                      border: '1px solid var(--black-color)',
                    }}
                    isLatestButton={true}
                  />
                </div>
              </Content>
            </Col>
            <Col x={0} md={1} xl={2}></Col>
          </Row>
        </Content>
      </Spin>
    </React.Fragment>
  );
};

export default MypagePointPresenter;
